/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Management_Item_1_BodyInputs */

const en_wb_management_item_1_body = /** @type {(inputs: Wb_Management_Item_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`proposal ready for the account owner’s review.`)
};

const lv_wb_management_item_1_body = /** @type {(inputs: Wb_Management_Item_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`piedāvājums gatavs par klientu atbildīgā darbinieka pārbaudei.`)
};

/**
* | output |
* | --- |
* | "proposal ready for the account owner’s review." |
*
* @param {Wb_Management_Item_1_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_management_item_1_body = /** @type {((inputs?: Wb_Management_Item_1_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Management_Item_1_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_management_item_1_body(inputs)
	return en_wb_management_item_1_body(inputs)
});